import React, { memo } from 'react';
import '../../../Common/Filters/Filters.css';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';
import DatePeriodField from '../../../../../../core/components/core/Util/Form/CustomInputs/DatePeriod';
import MultipleSelect from '../../../Common/Filters/MultipleSelect';
import useLocations from './hooks/useLocations';

const Filters = ({ className = '' }) => {
    const { handleChangeFilters, filters, onFilterChange } =
        useFiltersContext();
    const { data } = useLocations(filters?.cidade?.value);

    const onFilterChangeDate = (value_start, value_end) => {
        const newFilters = {
            ...filters,
            data_inicio: value_start,
            data_fim: value_end
        };
        handleChangeFilters(newFilters);
    };

    const locations = data || [];

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Município de Residência"
                options={[
                    { value: '', label: 'Todos' },
                    ...locations.map((location) => ({
                        value: location.co_municipio_ibge_residencia,
                        label: location.city_name
                    }))
                ]}
                onChange={onFilterChange}
                name="unidade"
                className="select-unidade-dashboards h-50"
                defaultValue={filters.unidade}
            />
            <div
                style={{
                    width: '300px'
                }}
            >
                <DatePeriodField
                    name_start="data_inicio"
                    name_end="data_fim"
                    onChange={({ target }) =>
                        onFilterChangeDate(target.value_start, target.value_end)
                    }
                    value={filters.data_inicio}
                    valueEnd={filters.data_fim}
                    containerClassName="m-0 "
                />
            </div>
        </div>
    );
};

export default memo(Filters);
